import {
  EChannelTypeGlobal,
  EDatasetKey,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

export function getKeywordsEDatasetKeyFromChannelTypeGlobal(
  channelType?: EChannelTypeGlobal
) {
  switch (channelType) {
    case EChannelTypeGlobal.SponsoredProduct:
      return EDatasetKey.KeywordSp
    case EChannelTypeGlobal.DisplayAd:
      return EDatasetKey.KeywordDa
    default: // eventually we should add generic and throw error if other
      return EDatasetKey.KeywordSp
  }
}
